import { BiWallet } from "react-icons/bi";
import { FaNairaSign } from "react-icons/fa6";
import { MdContentCopy } from "react-icons/md";
import styled from "styled-components";

interface IWalletInfo {
  balance: number;
  accountNumber: number;
}

const WalletInfoWrapper = styled.div`
  width: 100%;
  padding: 2rem 3rem;
  background-color: ${({ theme }) => theme.bg.secondary};
  color: white;
  border-radius: 0.5rem;
  position: relative;
  overflow: hidden;

  .balance-info {
    display: flex;
    align-items: center;
    gap: 1.5rem;

    .svg {
      padding: 0.8rem;
      background-color: ${({ theme }) => theme.bg.sec_100};
      border-radius: 100%;
      color: white;
    }
  }

  .account-info {
    margin-top: 0.5rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0.5rem 2rem;
    border-radius: 0.3rem;
    background-color: ${({ theme }) => theme.bg.sec_100};
    position: relative;
    z-index: 40;
  }

  .info {
    h1 {
      font-weight: 600;
      display: flex;
      gap: 3px;
      align-items: center;
    }
  }

  .circle1 {
    width: 200px;
    height: 200px;
    border-radius: 100%;
    background-color: ${({ theme }) => theme.bg.sec_100};
    position: absolute;
    top: -40px;
    right: -40px;
    opacity: 0.7;
  }
  .circle2 {
    width: 200px;
    height: 200px;
    border-radius: 100%;
    background-color: ${({ theme }) => theme.bg.sec_100};
    position: absolute;
    bottom: -100px;
    left: -100px;
    opacity: 0.7;
  }
`;

const WalletInfo = ({ balance, accountNumber }: IWalletInfo) => {
  const handleCopy = () => {
    alert("copy called");
  };
  return (
    <WalletInfoWrapper>
      <div className="balance-info">
        <div className="svg">
          <BiWallet color="white" size={32} />
        </div>
        <div className="info">
          <h2>Available balance</h2>
          <h1 className="balance">
            <FaNairaSign size={14} />
            <span>{balance}</span>
          </h1>
        </div>
      </div>
      <div className="account-info">
        <div className="info">
          <h2>Account Number</h2>
          <h1>{accountNumber}</h1>
        </div>
        <MdContentCopy
          className="cursor-pointer"
          onClick={handleCopy}
          size={30}
        />
      </div>
      {/* ==SVG Circles== */}
      <div className="circle1"></div>
      <div className="circle2"></div>
    </WalletInfoWrapper>
  );
};

export default WalletInfo;
